<div class="tile__header tile__header--image">
  <div class="tile__expander">
    <img
      src="{{ item.hero.tegel.url }}"
      alt="{{ item.hero.description }}"
      class="img--contain is-wider"
    />
  </div>
</div>

<div class="tile__headerHolder">
  <div class="tile__title">
    <h3 class="tile__heading headingM">{{ item.tileTitel }}</h3>
  </div>

  <div class="tile__specs">
    <p class="grey small">{{ item.afstandTekstvorm }}</p>
  </div>
</div>

<div
  *ngIf="item?.stickerTekst"
  class="tile__sticker tile__sticker--compact promosticker"
>
  <span class="promosticker__text promosticker__text--right">{{
    item.stickerTekst
  }}</span>
</div>

<div class="tile__content">
  {{ item.locatieTekst }}
</div>

<div class="tile__footer">
  <p>
    <a
      href="{{ item.url }}"
      class="arrowLink"
      title="{{ item.tileTitel }}"
      [attr.data-eventdata]="
        '{
            &quot;data&quot; : {
                &quot;path&quot; : &quot;' +
        item.path +
        '&quot;,
                &quot;name&quot; : &quot;' +
        item.naam +
        '&quot;,
                &quot;type&quot; : &quot;wandeling&quot;,
                &quot;linkname&quot; : &quot;' +
        LINK_LABEL +
        '&quot;,
                &quot;url&quot; : &quot;' +
        item.url +
        '&quot;
            },
            &quot;category&quot; : &quot;userinteractie/clicks/links&quot;,
            &quot;eventname&quot; : &quot;click&quot;
        }'
      "
      >{{ LINK_LABEL }}</a
    >
  </p>
</div>
